import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Inject } from 'vue-di-container';
import WithRender from './SenderConectivitySupport.html';
import { SenderConectivityDetailModel } from './SenderConectivityDetailModel';
import { Toaster } from '../../Services/toast';
import { SenderConectivityStatus } from '../../shared/Enums/SenderConectivityStatus';
import ShortService from '../Short/ShortService';
import { SenderType } from '../../shared/Enums/SenderType';
import UserService from '../../shared/userService/UserService';
import { SenderConectivityDetaillogModel } from './SenderConectivityDetaillogModel';
import SenderConectivitySupportService from './SenderConectivitySupportService';
import ProviderService from '../Provider/ProviderService';
import { SearchModel } from './SearchModel';
import { DropdownModel } from '../Provider/ProviderModel';
import { SenderStatus } from '../../shared/Enums/SenderStatus';
import UserRoleService from '../../shared/userService/UserRoleService';
import SenderConectivityDetailService from '../SenderConectivityDetail/SenderConectivityDetailService';
import OperatorService from '@/Services/OperatorService';

@WithRender
@Component({
    components: {
    },
    diProvide: [
        SenderConectivitySupportService,
        ShortService,
        UserService,
        ProviderService,
        UserRoleService,
        SenderConectivityDetailService,
        OperatorService
    ],
})
export default class SenderConectivitySupport extends Vue {
    @Inject(SenderConectivitySupportService) public senderConectivityService!: SenderConectivitySupportService;
    @Inject(SenderConectivityDetailService) public senderConectivityServiceDetails!: SenderConectivityDetailService;
    @Inject(ShortService) public shortService!: ShortService;
    @Inject(ProviderService) public providerService!: ProviderService;
    @Inject(UserService) public userService!: UserService;
    @Inject(UserRoleService) public userRoleService!: UserRoleService;
    @Inject(OperatorService) public operatorService!: OperatorService;
    @Prop({ type: Boolean, default: false })
    public layoutSup: boolean | any;

    @Prop({ type: String, default: '' })
    public senderId: string | any;
    public createdDateFromMenu = false;
    public createdDateToMenu = false;
    public isModeShow: boolean = false;
    public deleteDialog: boolean = false;
    public addDialog: boolean = false;
    public logDialog: boolean = false;
    public markAsAddedDialog: boolean = false;
    public markAsDeletedDialog: boolean = false;
    public resendToOperatorDialog: boolean = false;
    public resendToOperatorBulkDialog: boolean = false;
    public connectivitiesCount: number = 0;
    public providerOptions: DropdownModel[] = [];
    public senderOptions: any[] = [];
    public conectivityId: string = '';
    public senderType: SenderType[] = [];
    public isAlreadyExistEnabled: boolean = false;
    public User: any;
    public userRole: any;
    public pageSize: string = '10';
    public pageIndex: string = '0';
    public pagination: any = {};
    public selected: SenderConectivityDetailModel[] = [];
    public headers: any = [
        { text: this.$t('shortPage.company'), sortable: false, value: 'operator', align: 'center' },
        { text: this.$t('shortPage.shortCode'), sortable: false, value: 'shortCodeName', align: 'center' },
        { text: this.$t('shared.senderName'), sortable: false, value: 'senderName', align: 'center' },
        { text: this.$t('shared.provider'), sortable: false, value: 'providerName', align: 'center' },
        { text: this.$t('shared.senderType'), sortable: false, value: 'senderType', align: 'center' },
        { text: this.$t('shared.createddate'), sortable: true, value: 'createdDate', align: 'center' },
        { text: this.$t('shared.lastModifiedDate'), sortable: true, value: 'lastModifiedDate', align: 'center' },
        { text: this.$t('shared.conectivityStatus'), sortable: false, value: 'status', align: 'center' },
        { text: this.$t('shared.actions'), sortable: false, value: 'id', align: 'center', width: '100' },
    ];
    public changeSort(column: any) {
        if (this.pagination.sortBy === column) {
            this.pagination.descending = !this.pagination.descending;
        } else {
            this.pagination.sortBy = column;
            this.pagination.descending = false;
        }
        this.updatePaginate(this.pagination);
    }
    public senderStatusList: DropdownModel[] = [
        {
            id: SenderStatus.Approved,
            name: this.$t('dashboardPage.active').toString(),
        },
        {
            id: SenderStatus.Deactivated,
            name: this.$t('shared.Deactivated').toString(),
        },
        {
            id: SenderStatus.Expired,
            name: this.$t('shared.Expired').toString(),
        },
        {
            id: SenderStatus.Deleted,
            name: this.$t('shared.Deleted').toString(),
        },
    ];
    public senderConectivityStatusOptions: DropdownModel[] = [];
    public setupStatusOptions() {
        this.senderConectivityStatusOptions = [
            {
                id: SenderConectivityStatus.Added,
                name: this.$t('shared.added').toString(),
            },
            {
                id: SenderConectivityStatus.PendingAddition,
                name: this.$t('shared.pendingAddition').toString(),
            },
            {
                id: SenderConectivityStatus.Deleted,
                name: this.$t('shared.deleted').toString(),
            },
            {
                id: SenderConectivityStatus.PendingDeletion,
                name: this.$t('shared.pendingDeletion').toString(),
            },
            {
                id: SenderConectivityStatus.Canceled,
                name: this.$t('shared.canceled').toString(),
            },
            {
                id: SenderConectivityStatus.Skipped,
                name: this.$t('shared.skipped').toString(),
            },
        ];

        if (this.userRole === 2 || this.userRole === 5) {
            this.senderConectivityStatusOptions = this.senderConectivityStatusOptions.filter(
                option => option.id !== SenderConectivityStatus.Skipped
            );
        }
    }

    public companyOptions: DropdownModel[] = [];

    public operatorOptions: any[] = [];
    public senderTypeOptions: any[] = [];
    public model: SearchModel = {
        senderName: '',
        providerId: '',
        shortcode: '',
        senderConectivityStatus: [],
        operatorCompany: [],
        createdDateFrom: '',
        createdDateTo: '',
    };
    public connectivities: SenderConectivityDetailModel[] = [];
    public logModel: SenderConectivityDetaillogModel = {
        id: '',
        addRequest: '',
        addResponse: '',
        deleteRequest: '',
        deleteResponse: '',
    };
    public statusOptions: any[] = [
        {
            id: SenderConectivityStatus.Added,
            name: this.$t('shared.added').toString(),
        },
        {
            id: SenderConectivityStatus.Deleted,
            name: this.$t('shared.deleted').toString(),
        },
        {
            id: SenderConectivityStatus.PendingAddition,
            name: this.$t('shared.pendingAddition').toString(),
        },
        {
            id: SenderConectivityStatus.PendingDeletion,
            name: this.$t('shared.pendingDeletion').toString(),
        },
        {
            id: SenderConectivityStatus.Skipped,
            name: this.$t('shared.skipped').toString(),
        },
        {
            id: 0,
            name: this.$t('shared.allConnectivityStatuses').toString(),
        },
    ];
    public GetUserRole() {
        return this.userRoleService.GetUserRole(this.User);
    }
    public async created() {
        const response = await this.operatorService.getAll();
        if (response.isSuccess) {
            this.companyOptions = response.result;
        }

        this.User = await this.userService.getUser();
        this.userRole = this.GetUserRole();
        this.setupHeaders();
        this.setupStatusOptions();
        if (this.userRole !== 2 && this.userRole !== 5) {
            const providerOptionsResp = await this.providerService.GetOptions();
            this.providerOptions = providerOptionsResp.result as DropdownModel[];
        }
        this.$emit('childinit', this.layoutSup);
    }
    public setupHeaders() {
        this.headers = [
            { text: this.$t('shortPage.company'), sortable: false, value: 'operator', align: 'center' },
            { text: this.$t('shortPage.shortCode'), sortable: false, value: 'shortCodeName', align: 'center' },
            { text: this.$t('shared.senderName'), sortable: false, value: 'senderName', align: 'center' },
            { text: this.$t('shared.provider'), sortable: false, value: 'providerName', align: 'center' },
            { text: this.$t('shared.senderType'), sortable: false, value: 'senderType', align: 'center' },
            { text: this.$t('shared.createddate'), sortable: true, value: 'createdDate', align: 'center' },
            { text: this.$t('shared.lastModifiedDate'), sortable: true, value: 'lastModifiedDate', align: 'center' },
            { text: this.$t('shared.conectivityStatus'), sortable: false, value: 'status', align: 'center' },
            { text: this.$t('shared.actions'), sortable: false, value: 'id', align: 'center', width: '100' },
        ];
        if (this.userRole === 2 || this.userRole === 5) {
            this.headers = this.headers.filter((h: { value: string }) => h.value !== 'providerName' && h.value !== 'id');
        }
    }

    public get isSuperUser(): boolean {
        return (
            this.User.details.Role === 'Support' ||
            this.User.details.Role === 'Super Admin'
        );
    }
    public async mounted() {
        const option = await this.senderConectivityService.getConnectivityConfiguration();
        this.isAlreadyExistEnabled = option.result.isAlreadyExistEnabled;
        let sumSenderType = 0;
        let sumSenderTypeText = '';
        this.senderType.filter((x) => x !== 1).forEach((x, index) => {
            sumSenderType += x;
            sumSenderTypeText += this.getSenderTypeText(x);
            if (this.senderType.filter((y) => y !== 1).length !== index + 1) {
                sumSenderTypeText += ' , ';
            }
        });
        if (this.senderType.filter((x) => x === 1).length !== 0) {
            this.senderTypeOptions.push({
                id: 1,
                name: this.getSenderTypeText(1),
            });
        }
        if (sumSenderType !== 0) {
            this.senderTypeOptions.push({
                id: sumSenderType,
                name: sumSenderTypeText,
            });
        }
        this.senderConectivityStatusOptions.push
        this.search();
    }

    public async reset() {
        this.model.senderName = '';
        this.model.shortcode = '';
        this.model.providerId = '';
        this.model.senderConectivityStatus = [];
        this.model.operatorCompany = [];
        this.model.createdDateFrom = '';
        this.model.createdDateTo = '';
        this.pagination.sortBy = '';
        this.selected = [];
        this.search();
    }

    public async search() {
        if (this.userRole === 2 || this.userRole === 5) {
            this.model.providerId = this.User.details.providerId || '';
        }
        const response = await this.senderConectivityService.get(this.model.senderName, this.model.shortcode,
            this.model.providerId, this.model.senderConectivityStatus,
            this.model.operatorCompany, this.model.createdDateFrom,
            this.model.createdDateTo, this.pagination.descending, this.pagination.sortBy, this.pageIndex, this.pageSize);
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
        }
        this.connectivities = response.result;
        this.connectivitiesCount = response.totalCount;
    }
    public async getReport() {
        const response = await this.senderConectivityService.getReport(this.model.senderName, this.model.shortcode,
            this.model.providerId, this.model.senderConectivityStatus,
            this.model.operatorCompany, this.model.createdDateFrom,
            this.model.createdDateTo,
            this.pagination.descending, this.pagination.sortBy);
        this.search();
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
        }
    }

    public async updatePaginate(val: any) {
        this.pageIndex = (val.page - 1).toString();
        this.pageSize = val.rowsPerPage;
        const response = await this.senderConectivityService.get(this.model.senderName, this.model.shortcode,
            this.model.providerId, this.model.senderConectivityStatus,
            this.model.operatorCompany, this.model.createdDateFrom,
            this.model.createdDateTo, this.pagination.descending, this.pagination.sortBy
            , this.pageIndex, this.pageSize);
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
        }
        this.connectivities = response.result;
        this.connectivitiesCount = response.totalCount;
    }
   
   public getOperatorText(operatorId: number): string {
     const operator = this.companyOptions.find(op => op.id === operatorId);
       return operator ? operator.name : '-';
   }
    public getSenderTypeText(typeId: number) {
        switch (typeId) {
            case SenderType.Advertisement:
                return this.$t('shared.advertisement').toString();
            case SenderType.Service:
                return this.$t('shared.service').toString();
            case SenderType.Awareness:
                return this.$t('shared.awareness').toString();
            case SenderType.Warning:
                return this.$t('shared.warning').toString();
            default:
                return '-';
        }
    }

    public getSenderTypeTextTable(senderType: number) {
        let senderTypeText = '';
        const senderTypeList = [];
        if ((senderType & 1) === 1) {
            senderTypeList.push(this.getSenderTypeText(1));
        }
        if ((senderType & 2) === 2) {
            senderTypeList.push(this.getSenderTypeText(2));
        }
        if ((senderType & 4) === 4) {
            senderTypeList.push(this.getSenderTypeText(4));
        }
        if ((senderType & 8) === 8) {
            senderTypeList.push(this.getSenderTypeText(8));
        }
        senderTypeText = senderTypeList.join(' / ');
        return senderTypeText;
    }

    public getConectivityStatusText(status: number) {
        switch (status) {
            case SenderConectivityStatus.PendingAddition:
                return this.$t('shared.pendingAddition').toString();
            case SenderConectivityStatus.Added:
                return this.$t('shared.added').toString();
            case SenderConectivityStatus.PendingDeletion:
                return this.$t('shared.pendingDeletion').toString();
            case SenderConectivityStatus.Deleted:
                return this.$t('shared.deleted').toString();
            case SenderConectivityStatus.Canceled:
                return this.$t('shared.canceled').toString();
            case SenderConectivityStatus.Skipped:
                return this.$t('shared.skipped').toString();
            default:
                return '-';
        }
    }
    public isEqual(value1: string | null, value2: string) {
        return (value1 === '' || value1 === null || value1 === undefined || value2.includes(value1));
    }
    public async MarkAsAdded() {
        const response = await this.senderConectivityService.MarkAsAdded(this.conectivityId);
        if (response.isSuccess && response.result) {
            Toaster.success(this.$t('shared.ConvertedSuccessfully').toString());
            this.search();
        } else {
            Toaster.error(response.errorMessage);
        }
        this.markAsAddedDialog = false;
    }
    public async MarkAsDeleted() {
        const response = await this.senderConectivityService.MarkAsDeleted(this.conectivityId);
        if (response.isSuccess && response.result) {
            Toaster.success(this.$t('shared.ConvertedSuccessfully').toString());
            this.search();
        } else {
            Toaster.error(response.errorMessage);
        }
        this.markAsDeletedDialog = false;
    }
    public async resendToOperator() {
        const item = this.connectivities.find(x => x.id === this.conectivityId);
        if (!item) {
            Toaster.error(this.$t('shared.error').toString());
            this.resendToOperatorDialog = false;
            return;
        }

        let response;
        if (item.status === SenderConectivityStatus.Added) {
            response = await this.senderConectivityServiceDetails.markAsPendingAdditionBulk([this.conectivityId]);
        } else if (item.status === SenderConectivityStatus.Deleted) {
            response = await this.senderConectivityServiceDetails.markAsPendingDeletionBulk([this.conectivityId]);
        } else {
            Toaster.error(this.$t('shared.InvalidresendSelection').toString());
            this.resendToOperatorDialog = false;
            return;
        }

        if (response.isSuccess && response.result) {
            Toaster.success(this.$t('shared.resentSuccessfully').toString());
            this.search();
        } else {
            Toaster.error(response.errorMessage);
        }
        this.resendToOperatorDialog = false;
    }
    public async showlogDialog(id: string) {
        const response = await this.senderConectivityService.getLogDetails(id);
        this.logModel = response.result;
        this.logDialog = true;
    }
    public hidelogDialog() {
        this.logModel = {
            id: '',
            addRequest: '',
            addResponse: '',
            deleteRequest: '',
            deleteResponse: '',
        };
        this.logDialog = false;
    }
    public showMarkAsAddedDialog(id: string) {
        this.conectivityId = id;
        this.markAsAddedDialog = true;
    }
    public hideMarkAsAddedDialog() {
        this.markAsAddedDialog = false;
    }
    public showMarkAsDeletedDialog(id: string) {
        this.conectivityId = id;
        this.markAsDeletedDialog = true;
    }
    public hideMarkAsDeletedDialog() {
        this.markAsDeletedDialog = false;
    }
    public showResendToOperatorDialog(id: string) {
        this.conectivityId = id;
        this.resendToOperatorDialog = true;
    }
    public hideResendToOperatorDialog() {
        this.resendToOperatorDialog = false;
    }
    public showResendToOperatorBulkDialog() {
        if (this.isResendDisabled) {
            return;
        }
        const allAdded = this.selected.every(x => x.status === SenderConectivityStatus.Added);
        const allDeleted = this.selected.every(x => x.status === SenderConectivityStatus.Deleted);

        if (!allAdded && !allDeleted) {
            Toaster.error(this.$t('shared.InvalidresendSelection').toString());
            return;
        }

        this.resendToOperatorBulkDialog = true;
    }
    public hideResendToOperatorBulkDialog() {
        this.resendToOperatorBulkDialog = false;
    }
    public save() {
        this.isModeShow = true;
    }
    public back() {
        this.isModeShow = false;
    }
    public get isValid(): boolean {
        return (
            this.model.senderName.trim() !== ''
            || this.model.providerId !== ''
            || this.model.shortcode.trim() !== ''
            || (Array.isArray(this.model.senderConectivityStatus) && this.model.senderConectivityStatus.length > 0)
            || (Array.isArray(this.model.operatorCompany) && this.model.operatorCompany.length > 0)
            || this.model.createdDateFrom !== ''
            || this.model.createdDateTo !== ''
        );
    }
    public get isExportValid(): boolean {
        return (Array.isArray(this.model.operatorCompany) && this.model.operatorCompany.length > 0);
    }

    public onDateChange(field: 'from' | 'to') {
        if (field === 'from') this.createdDateFromMenu = false;
        if (field === 'to') this.createdDateToMenu = false;

        this.search();
    }

    public get isResendDisabled(): boolean {
        return !this.isSuperUser || !this.selected || this.selected.length === 0;
    }

    public async resendToOperatorBulk() {
        if (this.isResendDisabled) return;

        const INVALID_FOR_ANY_SELECTION = [
            SenderConectivityStatus.PendingAddition,
            SenderConectivityStatus.Deleted,
            SenderConectivityStatus.Canceled
        ];

        const hasInvalid = this.selected.some(
            x => x.status !== SenderConectivityStatus.Added || INVALID_FOR_ANY_SELECTION.includes(x.status)
        );
        if (hasInvalid) {
            Toaster.error(this.$t('shared.Invalidresendtooperator').toString());
            this.resendToOperatorBulkDialog = false;
            return;
        }

        const ids = this.selected.map(x => x.id);
        if (!ids.length) return;

        const response = await this.senderConectivityServiceDetails.markAsPendingAdditionBulk(ids);
        if (response.isSuccess && response.result) {
            Toaster.success(this.$t('shared.resentSuccessfully').toString());
            this.selected = [];
            this.search();
        } else {
            Toaster.error(response.errorMessage);
            this.resendToOperatorBulkDialog = false;
        }
    }

    public async resendToOperatordeletionBulk() {
        if (this.isResendDisabled) return;

        const INVALID_FOR_ANY_SELECTION = [
            SenderConectivityStatus.PendingAddition,
            SenderConectivityStatus.Added,
            SenderConectivityStatus.Canceled
        ];

        const hasInvalid = this.selected.some(
            x => x.status !== SenderConectivityStatus.Deleted || INVALID_FOR_ANY_SELECTION.includes(x.status)
        );
        if (hasInvalid) {
            Toaster.error(this.$t('shared.Invalidresendtooperatordeletion').toString());
            this.resendToOperatorBulkDialog = false;
            return;
        }

        const ids = this.selected.map(x => x.id);
        if (!ids.length) return;

        const response = await this.senderConectivityServiceDetails.markAsPendingDeletionBulk(ids);
        if (response.isSuccess && response.result) {
            Toaster.success(this.$t('shared.resentSuccessfully').toString());
            this.selected = [];
            this.search();
        } else {
            Toaster.error(response.errorMessage);
            this.resendToOperatorBulkDialog = false;
        }
    }

    public async handleResendAction() {
        if (this.isResendDisabled) return;
        this.resendToOperatorBulkDialog = false;

        const allAdded = this.selected.every(x => x.status === SenderConectivityStatus.Added);
        const allDeleted = this.selected.every(x => x.status === SenderConectivityStatus.Deleted);

        if (allAdded) {
            await this.resendToOperatorBulk();
        } else if (allDeleted) {
            await this.resendToOperatordeletionBulk();
        } else {
            Toaster.error(this.$t('shared.InvalidresendSelection').toString());
            this.resendToOperatorBulkDialog = false;
        }
    }

}
